/** Explorer specific mixins */

export const LEFT_DRAWER_WIDTH = 450;
export const RIGHT_DRAWER_WIDTH = 330;

const dimensions = {
  topNav: {
    height: 40,
  },
  sidebarTab: {
    height: 8 * 6,
    insetBlock: 8 * 6 + 1, // 1 for the border
  },
  leftSidebar: {
    widthCollapsed: 46,
    width: LEFT_DRAWER_WIDTH,
    contentMargin: 2 * 8,
  },
  rightSidebar: {
    width: RIGHT_DRAWER_WIDTH,
  },
  timeline: {
    height: 8 * 11,
  },
  statusbar: {
    height: 8 * 4,
  },
  compareTools: {
    height: 8 * 6.5,
  },
  map: {
    locationSearchHeight: 8 * 5,
    toolMargin: 8 * 1.5,
    zoomToolbarWidth: 8 * 5,
  },
} as const;

export default dimensions;
